/*
 * Copyright (c) 2023
 *
 * The source code and all documents related to the source code ("Material") are owned by
 * Frictionless Systems, LLC.
 *
 * The Material contains trade secrets, proprietary information, and confidential information.
 * No part of the Material may be used, copied, reproduced, modified, published, distributed, or
 * disclosed in any way without Frictionless Systems, LLC’s express prior written permission.
 *
 * The Material may be protected under patent, trademark, copyright, or trade secret laws.  No
 * license is granted to you by disclosure or delivery of the Materials.  Any license must be
 * express and approved by Frictionless Systems, LLC in writing.
 *
 * “Frictionless Systems” and “Impulse” are registered trademarks of Frictionless Systems, LLC.
 */

package systems.frictionless.impulse.browser.composable.component

import androidx.compose.runtime.Composable
import org.jetbrains.compose.web.attributes.name
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Label
import org.jetbrains.compose.web.dom.RadioInput
import org.jetbrains.compose.web.dom.Span
import systems.frictionless.impulse.browser.id.HtmlId
import systems.frictionless.impulse.browser.style.AppStyleSheet
import systems.frictionless.impulse.rest.model.Index

/**
 * @param label Text to display next to the radio choice.
 * @param isSelected True if this radio choice is the selected option.
 * @param index Index from multiple choices.  See [HtmlId.radioChoiceIndex].  Used for automated testing.
 * @param onSelected Callback if this choice is selected by the user.
 */
@Composable
internal fun RadioChoice(
    label: String,
    isSelected: Boolean,
    name: String,
    index: Index,
    onSelected: () -> Unit
) {
    Div(attrs = {
        classes(AppStyleSheet.singleChoiceContainer)
    }) {
        Label(attrs = {
            classes(AppStyleSheet.singleChoice)
        }) {
            RadioInput(checked = isSelected, attrs = {
                name(name)
                id(HtmlId.radioChoiceIndex(index))
                onChange {
                    onSelected()
                }
            })
            Span(attrs = {
                classes(AppStyleSheet.checkMark)
            })
            Text(label)
        }
    }
}
